import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
var resetFieldStyles = "\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  outline: none;\n  border: 0px;\n  margin: 0px;\n  padding: 0px;\n  background-color: transparent;\n  width: 100%;";
export var TextareaField = styled.textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  resize: none;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  min-height: ", ";\n  padding: 12px 0px;\n  ", "\n\n  &::-webkit-scrollbar {\n    width: 0px;\n    background: transparent;\n  }\n"])), resetFieldStyles, function (_ref) {
  var theme = _ref.theme,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  return theme.form.size[size].fontSize;
}, function (_ref2) {
  var theme = _ref2.theme,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size;
  return theme.form.size[size].lineHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.families.base;
}, function (_ref4) {
  var minHeight = _ref4.minHeight;
  return minHeight ? minHeight + 'px' : '126px';
}, function (_ref5) {
  var maxLength = _ref5.maxLength;
  return maxLength ? 'margin-bottom: 20px;' : '';
});
export var CustomSup = styled.sup(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: red;\n"])));